<template>
  <div>
    <p class="subheading font-weight-black grey--text text--darken-2 mb-1">
      Seja bem-vindo ao
    </p>
    <h1 class="display-1 font-weight-black primary--text mb-2">
      Portal do Beneficiário
    </h1>
    <p class="subheading">Insira seus dados abaixo para acessar o portal.</p>
    <v-form
      ref="form"
      v-model="valido"
      @keyup.native.enter="valido && enviar()"
    >
      <v-autocomplete
        required
        v-model="unimed"
        :items="unimeds"
        item-text="nome"
        item-value="id"
        label="Unimed"
        name="unimed"
        :rules="unimedRules"
        clearable
        no-data-text="Nenhum resultado encontrado"
      ></v-autocomplete>
      <v-text-field
        required
        data-cy="signinEmailField"
        label="E-mail ou CPF"
        name="username"
        type="text"
        v-model="username"
        :rules="usernameRules"
      ></v-text-field>
      <v-text-field
        required
        data-cy="signinPasswordField"
        label="Senha"
        name="password"
        :type="mostrarSenha ? 'text' : 'password'"
        v-model="password"
        :rules="passwordRules"
        :append-icon="mostrarSenha ? 'visibility_off' : 'visibility'"
        @click:append="mostrarSenha = !mostrarSenha"
      ></v-text-field>
    </v-form>
    <v-spacer></v-spacer>
    <v-layout align-center justify-space-between row fill-height>
      <v-btn
        flat
        class="body-2 text-none mx-0 px-1"
        color="grey darken-2"
        :to="{ name: 'recuperar-senha' }"
        >Esqueci a senha</v-btn
      >
      <v-btn
        light
        class="mr-0"
        data-cy="signinSubmitBtn"
        :color="highContrast ? 'white' : 'primary'"
        :disabled="!valido"
        @click="enviar"
        >Acessar</v-btn
      >
    </v-layout>
    <p class="mt-4 subheading">
      Primeiro acesso?
      <v-btn
        flat
        class="body-2 text-none mx-0 px-1"
        color="grey darken-2"
        :to="{ name: 'primeiro-acesso' }"
        >Faça seu cadastro novo aqui</v-btn
      >
    </p>
  </div>
</template>

<script>
import { storage } from "@/plugins";

import auth from "./auth";

export default {
  name: "Acessar",
  props: {
    highContrast: Boolean,
    unimeds: Array,
    product: String
  },
  data() {
    return {
      redirect: null,
      password: "",
      unimed: null,
      username: "",
      valido: false,
      mostrarSenha: false,
      passwordRules: [
        value => !!value || "A senha é obrigatória",
        value =>
          value.length >= 8 || "A senha deve ser maior do que 8 caracteres"
      ],
      unimedRules: [value => !!value || "É obrigatório selecionar uma Unimed"],
      usernameRules: [value => !!value || "O E-mail/CPF é obrigatório"]
    };
  },
  created() {
    this.loginAutomatico();
    this.unimedSelecionada();

    if (this.$route.query.redirect) {
      this.redirect = this.$route.query.redirect;

      this.$store.commit(
        "portal/setToast",
        "Sua sessão expirou. Efetue login novamente"
      );
    }
  },
  methods: {
    enviar() {
      if (this.$refs.form.validate()) {
        const params = {
          password: this.password,
          unimed: this.unimed,
          username: this.username,
          redirect: this.redirect
        };

        this.$emit("login", params);
      }
    },
    loginAutomatico() {
      const token = this.$route.params.token;

      if (token) {
        auth.loginAutomatico(token, this.$store, this.$router, this.product);
      }
    },
    unimedSelecionada() {
      const unimed = storage.getItem("unimed");
      const unimedSelecionada = unimed ? Number(unimed) : null;

      this.unimed = unimedSelecionada;
    }
  }
};
</script>
